module.exports = __webpack_public_path__ + "img/01_ic_wires_black_62px.2711823a.svg";